/** Static vector art: a banked disc, parallel flight paths and an ultimate
 * field with two end zones. Phones omit fine detail; fixed stroke widths
 * keep the remaining contours readable at the compact size. */
export function DiscFlightArt() {
  return (
    <svg
      className="h-auto w-full"
      viewBox="0 0 440 260"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <g className="hidden sm:block" stroke="currentColor" strokeWidth="1.25" opacity="0.22">
        <path d="m46 201 186-64 173 42-186 64Z" />
        <path d="m83 188 173 42m-61-80 173 42" />
      </g>
      <g stroke="currentColor" strokeWidth="1.5">
        <path className="hidden sm:block" d="M26 117C46 170 112 177 198 112" opacity="0.25" />
        <path
          d="M21 143C52 195 132 193 219 127"
          opacity="0.45"
          vectorEffect="non-scaling-stroke"
          strokeWidth="1"
        />
        <path className="hidden sm:block" d="M28 173C76 222 159 206 240 141" opacity="0.7" />
      </g>
      <path
        d="M88 205C132 215 186 191 240 147"
        stroke="var(--brand)"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
      <g transform="translate(282 98) rotate(-23)">
        <path
          d="M-116 0v10a116 43 0 0 0 232 0V0"
          fill="var(--background)"
          stroke="currentColor"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <ellipse
          rx="116"
          ry="43"
          fill="var(--background)"
          stroke="var(--brand)"
          strokeWidth="2"
          vectorEffect="non-scaling-stroke"
        />
        <ellipse
          rx="99"
          ry="32"
          stroke="currentColor"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <g className="hidden sm:block">
          <ellipse rx="86" ry="25" stroke="currentColor" strokeWidth="1" opacity="0.45" />
          <ellipse rx="15" ry="4.5" stroke="var(--brand)" strokeWidth="1.5" />
        </g>
      </g>
    </svg>
  );
}
